import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { COLOR_APP } from "../../../constants";
import Cookies from "js-cookie";
import { IoSearchOutline } from "react-icons/io5";
import UserLoading from "./UserLoading";

const PersonList = ({
  fbUsers,
  isLoading,
  selectedFbUser,
  setSelectedFbUser,
  selectedPage,
  setSelectedPage,
}) => {
  // const fbPageList = JSON.parse(Cookies.get('SHOP_PAGE')) || [];
  const shopPageCookie = Cookies.get("SHOP_PAGE");
  const fbPageList = shopPageCookie ? JSON.parse(shopPageCookie) : [];
  // const fbPageList = JSON.parse(localStorage.getItem('SHOP_PAGE')) || [];

  useEffect(() => {
    if (fbPageList?.length > 0) {
      setSelectedPage(fbPageList[0]);
    }
  }, [JSON.stringify(fbPageList)]);
  const _handleSelectFbUser = (fbUser) => {
    try {
      console.log({ fbUser });
      setSelectedFbUser(fbUser);
    } catch (error) {
      console.log({ error });
    }
  };

  const _isSelectedFbUser = (fbUserId) => {
    return fbUserId === selectedFbUser?.id;
  };

  const handleSelectChange = (e) => {
    const selectedPageId = e.target.value;
    const selectedPageData = fbPageList.find(
      (page) => page.id === selectedPageId
    );
    setSelectedPage(selectedPageData);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div>
        <div className="header-person">
          <div className="icon-search">
            <IoSearchOutline />
          </div>
          <input className="form-search-fb-user" placeholder="Search users" />
        </div>
        {/* <select onChange={handleSelectChange}
                className="form-control">
                {
                    fbPageList?.map((fbPage) => {
                        return <option value={fbPage?.id} key={fbPage?.id} onClick={() => setSelectedPage(fbPage)}>{fbPage?.name}</option>
                    })
                }
            </select> */}
      </div>
      {/* <div style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 5 }}>
            ລູກຄ້າ
        </div> */}
      <div>
        {isLoading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
             {/* <UserLoading /> */}
             <Spinner size="sm" animation="border" />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              overflow: "auto",
              height: "80vh",
            //   paddingBottom: 20,
            }}
          >
            {fbUsers?.map((user) => {
              return (
                <div
                  style={{
                    background: _isSelectedFbUser(user?.id) && "#ddd",
                    padding: 10,
                    borderRadius: 5,
                    display: "flex",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                  }}
                  onClick={() => _handleSelectFbUser(user)}
                >
                  <img
                    style={{ width: 40, height: 40, borderRadius: "100%" }}
                    alt=""
                    src={user?.picture}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: "bold",
                        display: "inline-block",
                        maxWidth: "150px", // You can adjust this width as needed
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {user?.senders?.data[0]?.name}
                    </span>
                    <span
                      style={{
                        fontSize: 12,
                        display: "inline-block",
                        maxWidth: "150px", // You can adjust this width as needed
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {user?.messages?.data[0]?.message}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonList;
